module.exports = __webpack_public_path__ + "static/media/mast.dd1e984b.jpg";